export default "__VITE_ASSET__BV03M7Av__"